import React,{useState,useEffect} from 'react'
import bab from '../assets/img/bab.jpeg'
import { ArrowRightCircle } from 'react-bootstrap-icons';
import { Container, Row, Col } from "react-bootstrap";
const Banner = () => {
    const [loopNum, setLoopNum] = useState(0);
    const [isDeleting, setIsDeleting] = useState(false);
    const [text, setText] = useState('');
    const [delta, setDelta] = useState(300 - Math.random() * 100);
    const [index, setIndex] = useState(1);
    const toRotate = [ "front-end Developer", "Back-end Developer", "UI/UX Designer" ];
    const period = 2000;
  
    useEffect(() => {
      let ticker = setInterval(() => {
        tick();
      }, delta);
  
      return () => { clearInterval(ticker) };
    }, [text])
  
    const tick = () => {
      let i = loopNum % toRotate.length;
      let fullText = toRotate[i];
      let updatedText = isDeleting ? fullText.substring(0, text.length - 1) : fullText.substring(0, text.length + 1);
  
      setText(updatedText);
  
      if (isDeleting) {
        setDelta(prevDelta => prevDelta / 2);
      }
  
      if (!isDeleting && updatedText === fullText) {
        setIsDeleting(true);
        setIndex(prevIndex => prevIndex - 1);
        setDelta(period);
      } else if (isDeleting && updatedText === '') {
        setIsDeleting(false);
        setLoopNum(loopNum + 1);
        setIndex(1);
        setDelta(500);
      } else {
        setIndex(prevIndex => prevIndex + 1);
      }
    }
  

  return (
    <section className="banner" id="home">
      <Container>
        <Row className="align-items-center">
        <Col  xs={12} md={6} xl={7} >
        <span className="tagline"> Welcome to my Portfolio</span>
       <h1>{`Hi! I'm Omnia`} <span className="txt-rotate" dataPeriod="1000" data-rotate='[ "frot-end Developer", "Back-end Developerr" ]'><span className="wrap">{text}</span></span></h1>

       <p>I'm a front-end web developer with 2 years of experience designing and building responsive web apps.
       Good at CSS, JavaScript 🟡, React, as well as good knowledge in Backend with Laravel</p>
       <button onClick={()=>console.log('connect')}>Lets Connect  <ArrowRightCircle  size={23}/></button>
       </Col>
       <Col xs={12} md={6} xl={5}>
         <img src={bab} alt="Header Img" />
       </Col>
        </Row>
      </Container>
    </section>
  )
}

export default Banner